import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../../common/namespace-classes';
var TableBody = /** @class */ (function (_super) {
    __extends(TableBody, _super);
    function TableBody() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableBody.prototype.render = function () {
        var props = this.props;
        var classNames = namespacedClassnames('table-body', props.className);
        return (React.createElement("div", { className: classNames }, props.children));
    };
    return TableBody;
}(React.Component));
export { TableBody };
//# sourceMappingURL=table-body.js.map